import { useQuery } from '@tanstack/react-query';
import { channelsApi } from '../services';

/**
 * Hook to fetch single channel by ID
 *
 * @example
 * const { data: channel, isLoading } = useChannel(channelId);
 */
export const useChannel = (id?: string) => {
  return useQuery({
    queryKey: ['channels', id],
    queryFn: () => channelsApi.getById(id!),
    enabled: !!id,
    staleTime: 5 * 60 * 1000,
  });
};
